import { render, staticRenderFns } from "./uploadCommonImg.vue?vue&type=template&id=16ae8a64&scoped=true&"
import script from "./uploadCommonImg.vue?vue&type=script&lang=js&"
export * from "./uploadCommonImg.vue?vue&type=script&lang=js&"
import style0 from "./uploadCommonImg.vue?vue&type=style&index=0&id=16ae8a64&prod&scoped=true&lang=scss&"
import style1 from "./uploadCommonImg.vue?vue&type=style&index=1&id=16ae8a64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ae8a64",
  null
  
)

export default component.exports